import React from 'react';
import CardList from './CardList';
import CardItem from './CardItem';

const Main = props => {
  const {
    isCreate,
    handleClick,
    data,
    value,
    handleDataList,
    handleDelete,
    handleShowModal,
    list,
    handleGetListId,
    listId,
    listName,
    handleItemData,
    dataItem,
    handleShowModalEdit,
    handleCancel,
    handleSaveItem,
    language,
    loading,
    lists,
    items,
    onEscape,
    showIcon,
    showItemIcon,
    handleShowTooltip,
    showEdit,
    showDelete,
    disableListHover,
    handleDisableListHover,
    handleSaveChanges,
    handleCancelChanges,
    isCancel,
    addItemError,
    showCancelOnTyping
  } = props;

  return (
    <div className="card-flex">
      <CardList
        title={language.card.list.title}
        create={language.card.list.create}
        name={language.card.list.name}
        action={language.card.list.action}
        legend={language.card.list.legend_text}
        isCrerate={isCreate}
        handleClick={handleClick}
        data={data.list}
        value={value}
        handleDataList={handleDataList}
        handleDelete={handleDelete}
        handleShowModal={handleShowModal}
        handleGetListId={handleGetListId}
        listId={listId}
        language={language}
        loading={loading}
        lists={lists}
        onEscape={onEscape}
        disableListHover={disableListHover}
      />

      <CardItem
        title={language.card.item.title}
        create={language.card.item.create}
        name={language.card.item.name}
        action={language.card.item.action}
        legend={language.card.item.legend_text}
        list={list}
        listId={listId}
        listName={listName}
        handleItemData={handleItemData}
        dataItem={dataItem}
        handleShowModal={handleShowModal}
        handleShowModalEdit={handleShowModalEdit}
        handleCancel={handleCancel}
        handleSaveItem={handleSaveItem}
        language={language}
        items={items}
        showIcon={showIcon}
        itemIcon={showItemIcon}
        handleShowTooltip={handleShowTooltip}
        showEdit={showEdit}
        showDelete={showDelete}
        handleDisableListHover={handleDisableListHover}
        handleSaveChanges={handleSaveChanges}
        handleCancelChanges={handleCancelChanges}
        isCancel={isCancel}
        handleShowTooltip={handleShowTooltip}
        addItemError={addItemError}
        showCancelOnTyping={showCancelOnTyping}
      />
    </div>
  );
};

export default Main;



// WEBPACK FOOTER //
// ./source/client/components/dynamic_list/main.jsx